import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faFile,
  faFileExcel,
  faFileImage,
  faFileLines,
  faFilePdf,
  faFilePowerpoint,
  faFileWord,
  faFileZipper,
} from '@fortawesome/pro-duotone-svg-icons';

const group = (icon: IconDefinition, extensions: string[]) =>
  extensions.map((extension) => [extension, icon] as const);

const ICON_BY_EXTENSION: ReadonlyMap<string, IconDefinition> = new Map([
  ...group(faFilePdf, ['pdf']),
  ...group(faFileWord, ['doc', 'docx', 'docm', 'dot', 'dotx', 'odt', 'rtf', 'pages']),
  ...group(faFileExcel, ['xls', 'xlsx', 'xlsm', 'xlt', 'xltx', 'ods', 'csv', 'numbers']),
  ...group(faFilePowerpoint, ['ppt', 'pptx', 'pptm', 'pot', 'potx', 'pps', 'ppsx', 'odp', 'key']),
  ...group(faFileZipper, ['zip', '7z', 'rar', 'tar', 'gz', 'tgz', 'bz2', 'xz', 'zst']),
  ...group(faFileImage, [
    'png',
    'jpg',
    'jpeg',
    'gif',
    'webp',
    'svg',
    'avif',
    'heic',
    'bmp',
    'tif',
    'tiff',
  ]),
  ...group(faFileLines, ['txt', 'md', 'log']),
]);

/**
 * Icon for a shared file: PDF, Office/OpenDocument formats, archives, images
 * and text get their own; anything else gets the generic file icon. The name's
 * extension decides first, the MIME type is the fallback.
 */
export function fileTypeIcon(name: string, mime = ''): IconDefinition {
  const dot = name.lastIndexOf('.');
  const extension = dot > 0 ? name.slice(dot + 1).toLowerCase() : '';
  const byExtension = ICON_BY_EXTENSION.get(extension);
  if (byExtension) return byExtension;
  if (mime === 'application/pdf') return faFilePdf;
  if (mime === 'application/zip') return faFileZipper;
  if (mime.startsWith('image/')) return faFileImage;
  if (mime.startsWith('text/')) return faFileLines;
  return faFile;
}
